import { SEARCH_TAGS, SEARCH_TAGS_SUCCESS, CLEAR_TAGS } from 'actionTypes';
import normalize, { tagUnionSchema } from 'schema';

export function searchTags(value) {
  return {
    type: SEARCH_TAGS,
    endpointArgs: { name: value },
  };
}

export function searchTagsSuccess(searchText, response) {
  const results = response.payload.results.map(res => ({
    ...res.object,
    schema: res.schema,
  }));
  return {
    type: SEARCH_TAGS_SUCCESS,
    searchText,
    normalizedData: normalize(results, [tagUnionSchema]),
  };
}

export function clearTags() {
  return {
    type: CLEAR_TAGS,
  };
}



// WEBPACK FOOTER //
// ./src/actions/tagActions.js